import React from "react";
import { ILanguageId } from "../../Language.props";
import EditLanguage from "./EditLanguage";

const EditLanguageIndex: React.FC<ILanguageId> = ({ languageId }) => {
  return <EditLanguage languageId={languageId} />;
};

export default EditLanguageIndex;
